var _circle, _path, _path2, _path3, _path4, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 424,
    viewBox: "0 0 424 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 212,
    r: 212,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207 207V5.0592C96.6489 7.67505 7.67505 96.6489 5.0592 207H207Z",
    fill: "#FF0000",
    stroke: "white",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M207 217H5.0592C7.67505 327.351 96.6489 416.325 207 418.941V217Z",
    fill: "#27AE61",
    stroke: "white",
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M217 217V418.941C327.351 416.325 416.325 327.351 418.941 217H217Z",
    fill: "#F1C40F",
    stroke: "white",
    strokeWidth: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M217 207H418.941C416.325 96.6489 327.351 7.67505 217 5.0592V207Z",
    fill: "#297FB8",
    stroke: "white",
    strokeWidth: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 212,
    r: 84,
    fill: "#3F3F3F",
    stroke: "white",
    strokeWidth: 20
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimon);
export default __webpack_public_path__ + "static/media/simon.c503b996cc642106bffdf058980a342b.svg";
export { ForwardRef as ReactComponent };